import React, { Fragment, useState, useEffect } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { Row, Col, Button } from "antd"
// import { ArrowRightOutlined } from '@ant-design/icons';

import BannerImage from '../../images/banner_image.png';
import {
  BannerSection,
  ContentContainer,
  Content,
  ServicesList,
  ImageContainer
} from './styles';
import Typed from 'react-typed';
import { textChangeFun, amountChangeFun } from "../../utils/utils";

export const HomeBannerSection = ({
  title,
  typedWords,
  services
}) => {

  return (
    <BannerSection>
      <Row>
        <Col className="contentSection">
          <ContentContainer>
            <Content>
            <span className="title_actual">{title}</span><br/>
            <span className="title_actual_mobile">{title}</span> {' '}
              {
                typedWords &&
                <Typed
                  strings={typedWords && typedWords.map((item) => amountChangeFun(textChangeFun(item)))}
                  typeSpeed={60}
                  backSpeed={60}
                  backDelay={1200}
                  loop
                  className="typeAnimation"
                />
              }
            </Content>
          </ContentContainer>
          <ServicesList>
            {
              services && services.map(dataItem => {
                const overrideUrls = {
                  "Manuscript Editing": "https://contentconcepts.com/services/manuscript-editing-service",
                  "Editing Certificate": "https://contentconcepts.com/editing-certificate",
                  "Our Editors": "https://contentconcepts.com/editors"
                };
                const href = overrideUrls[dataItem.title] || `https://contentconcepts.com${dataItem.link}`;
                return (
                  <li key={dataItem.id}>
                    <Button>
                      <a href={href}>{dataItem.title}</a>
                    </Button>
                  </li>
                );
              })
            }
          </ServicesList>
          {/* <Link to="/pricing/" id="view_prize">
            <Button id="view_prize" type="primary">Get Quote / See Price<ArrowRightOutlined className="icon" /></Button>
          </Link> */}
        </Col>
      </Row>
      <ImageContainer>
            <img src={BannerImage} alt="banner" />
      </ImageContainer>
    </BannerSection>
  );
};

const Banner = () => {

  const [content, setContent] = useState({});

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: {eq: "home/banner.md"}) {
        childMarkdownRemark {
          frontmatter {
            title
            typedWords
            services {
              id
              title
              link
            }
          }
        }
      }
    }
  `);

  useEffect(() => {
    if (data.file) {
      setContent(data.file.childMarkdownRemark.frontmatter);
    }
  }, [data.file]);

  return (
    <Fragment>
      {
        data.file &&
        <HomeBannerSection
          title={content.title}
          typedWords={content.typedWords}
          services={content.services}
        />
      }
    </Fragment>
  )
}

export default Banner
